export default {
  USER_AUTH: 'user_auth',
};
